import React from 'react';
import PropTypes from 'prop-types';

const SvgArrow = ({ active, ...props }) => {
    const fillColor = active ? '#ffffff' : '#343A72';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 25 25" {...props}>
            <path
                fill={fillColor}
                d="M.558 23.086a.625.625 0 0 0 .884.884l-.884-.884ZM24.528 0l-6.971 1.868L22.66 6.97 24.528 0ZM1.442 23.97l19.55-19.55-.884-.884-19.55 19.55.884.884Z"
            />
        </svg>
    );
};
SvgArrow.propTypes = {
    active: PropTypes.bool,
};
SvgArrow.defaultProps = {
    active: false,
};

export default SvgArrow;
